import { gql } from 'apollo-angular';
import { Task } from 'src/app/rent-module/shared/entities/task/task';

export const COMPLETE_TASK_QUERY = gql`
query getTask(
  $id: UUID,
  $commandInputs: [CommandInput]
)
{
  task: getTask(
    id: $id
  ){
    ... taskExcerpt
  }
}

fragment taskExcerpt on Task{
  id
  number
  type
  taskType {
    code
    name
    prefix
    icon
    color
  }
  completedDateTime
  createdDateTime
  timeEntriesSum
  commentCount
  fileCount
  commands(commandInputs: $commandInputs)
  taskType{
    code
    name
    prefix
    icon
    color
  }
  timeEntries {
    id
    taskId
    user{
      id
      firstName
      lastName
    }
    startDateTime
    endDateTime
    duration
    pauseDuration
    note
    category{
      name
      id
    }
  }
  completedBy{
    firstName
    lastName
  }
  dueDateTimePeriod {
    modifier
    dateTime
    fromDateTime
    toDateTime
    precision
  }
  state
  title
  description
  color
  context
  formControlTemplate
  order{
    note
  }
  address {
    id
    country
    city
    postalCode
    street
    houseNumber
    name
    lat
    lng
    text
    note
    type
    note
    geocodingResultGrade
    ref
  }
  createdBy {
    id
    firstName
    lastName
  }
  assignment {
    assigneeId
    assignmentType
    typeLabel
    name
  }
  assignmentSuggestion{
  	assigneeId
    assignmentType
    typeLabel
    name
  }
  aggregationRootId
}
`;

export interface CompleteTaskQuery {
  task: Task;
}

export const COMPLETE_TASK_MUTATION = gql`
mutation completeTask($taskId: UUID, $formModelInput: FormModelInput) {
  completeTask(
    taskId: $taskId,
    formModelInput: $formModelInput)
  {
      id
  }
}
`;

